import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import FontAwesome from 'react-fontawesome'
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import AuditoriaAcessoCrachaLiberacaoPeriodoMOTStore from "../stores/AuditoriaAcessoCrachaLiberacaoPeriodoMOTStore";
import {LoadingBlockFields} from  "../../comum/components/LoadingBlockFields";
import {MensagemErro} from "../../comum/components/MensagemErro";
import DataWrapper from "../../principal/containers/DataWrapper";
import {Filtro} from "../../comum/components/Filtro";
import {formatarCPF, formatarCNPJ} from "../../../utils/functions";
import {formatarDataHoraISO8601, formatarDataISO8601} from "../../../utils/formatar";

const FILTROS = ["COMPETENCIA_TERMINO_CONTRATO", "CPF", "MOT"];
const VALIDACOES = ["COMPETENCIA_TERMINO_CONTRATO_OBRIGATORIA"];

@inject("store")
@DataWrapper
@observer
export class AuditoriaAcessoCrachaLiberacaoPeriodoMOT extends Component {
    constructor(props) {
        super(props);
        this.controller = new AuditoriaAcessoCrachaLiberacaoPeriodoMOTStore();
        this.tituloPaginaStore = this.props.store.tituloPaginaStore;
    }

    componentDidMount() {
        this.tituloPaginaStore.setTitulo("Auditoria acessos, crachás e liberações pós período MOT");
    }

    render() {
        return (
            <div className="form-wrapper">
                <div className="content-panel">
                    <LoadingBlockFields carregando={this.controller.carregando}>
                        <Filtro onSubmit={(filtro) => this.controller.filtrar(filtro)}
                                history={this.props.history}
                                location={this.props.location}
                                controller={this.controller}
                                fields={FILTROS} 
                                validations={VALIDACOES}
                                onExportExcel={(filtro) => this.controller.onExportExcel(filtro)}
                                onExportPdf={(filtro) => this.controller.onExportPdf(filtro)} />
                        { this.controller.dados && this.controller.dados.length > 0 && !this.controller.erro &&
                            <BootstrapTable ref='table' version='4' data={this.controller.dados} striped hover pagination search condensed searchPlaceholder="Pesquisar">
                                {
                                    COLUMNS.map(column =>
                                        <TableHeaderColumn columnTitle { ...column } >
                                            { column.label }
                                        </TableHeaderColumn>
                                    )
                                }
                            </BootstrapTable>
                        }
                        {this.controller.erro &&
                            <MensagemErro>
                                {this.controller.erro}
                            </MensagemErro>
                        }
                    </LoadingBlockFields>
                </div>
            </div>
        )
    }
}

const COLUMNS = [
    { key: "1", label: "Número solicitação", dataField: "id", width: "150", dataSort: true, isKey: true },
    { key: "2", label: "N1", dataField: "area", width: "200", dataSort: true },
    { key: "3", label: "N2", dataField: "central", width: "200", dataSort: true },
    { key: "4", label: "N3", dataField: "divisao", width: "200", dataSort: true },
    { key: "5", label: "N4", dataField: "departamento", width: "200", dataSort: true },
    { key: "6", label: "Unidade de negócio (BU)", dataField: "empresa", width: "200", dataSort: true },
    { key: "7", label: "Gestor responsável", dataField: "gestorResponsavel", width: "200", dataSort: true },
    { key: "8", label: "CPF", dataField: "cpf", width: "200", dataSort: true, dataFormat: formatarCPF },
    { key: "9", label: "Nome", dataField: "nome", width: "200", dataSort: true },
    { key: "10", label: "Cargo", dataField: "cargo", width: "200", dataSort: true },
    { key: "11", label: "Admissão", dataField: "admissao", width: "150", dataSort: true, dataFormat: formatarDataISO8601 },
    { key: "12", label: "Término contrato", dataField: "terminoContrato", width: "150", dataSort: true, dataFormat: formatarDataISO8601 },
    { key: "13", label: "Término do período de quarentena", dataField: "terminoPeriodoQuarentena", width: "150", dataSort: true, dataFormat: formatarDataISO8601 },
    { key: "14", label: "Local acesso", dataField: "localAcesso", width: "200", dataSort: true },
    { key: "15", label: "Tipo acesso", dataField: "tipoAcesso", width: "100", dataSort: true },
    { key: "16", label: "Data início acesso", dataField: "dataInicioAcesso", width: "150", dataSort: true, dataFormat: formatarDataHoraISO8601 },
    { key: "17", label: "Data fim acesso", dataField: "dataFimAcesso", width: "150", dataSort: true, dataFormat: formatarDataISO8601 },
    { key: "18", label: "Matrícula responsável liberação acesso", dataField: "matriculaResponsavelLiberacaoAcesso", width: "100", dataSort: true },
    { key: "19", label: "Responsável liberação acesso", dataField: "responsavelLiberacaoAcesso", width: "200", dataSort: true },
    { key: "20", label: "Área responsável liberação acesso", dataField: "areaResponsavelLiberacaoAcesso", width: "200", dataSort: true },
    { key: "21", label: "Gestor responsável liberação acesso", dataField: "gestorResponsavelLiberacaoAcesso", width: "200", dataSort: true },
    { key: "22", label: "CNPJ vinculado ao crachá", dataField: "cnpjVinculadoCracha", width: "200", dataSort: true, dataFormat: formatarCNPJ },
    { key: "23", label: "Solicitante do crachá", dataField: "solicitanteCracha", width: "200", dataSort: true },
    { key: "24", label: "Formato de contratação", dataField: "formatoContratação", width: "200", dataSort: true }
];